import React, { Component } from 'react';

class TableFilters extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  shouldComponentUpdate(nextprops) {
    const element = document.getElementById(nextprops.id);
    if (typeof element !== 'undefined' && element !== null) {
      return false;
    }
    return true;
  }

  handleClick(evt, index) {
    evt.preventDefault();
    document.getElementById(index).checked =
      !document.getElementById(index).checked;
    this.props.onChange(document.getElementById(index));
  }

  handleKeyUp(e, id) {
    let filter;
    let a;
    let i;
    filter = e.target.value.toUpperCase();
    a = e.target.closest(`#${id}`).getElementsByTagName('li');
    for (i = 1; i < a.length; i++) {
      if (
        a[i]
          .getElementsByTagName('span')[0]
          .innerText.toUpperCase()
          .indexOf(filter) > -1
      ) {
        a[i].style.display = '';
      } else {
        a[i].style.display = 'none';
      }
    }
  }

  render() {
    const { props } = this;
    return (
      <div className="dropdown">
        <i
          id={props.id}
          style={{ top: props.position }}
          className="fa fa-caret-down fa-gray"
        ></i>
        <ul
          id={props.listid}
          className="dropdown-content-filter"
          style={{ maxHeight: '200px', overflowY: 'auto' }}
        >
          <li>
            <input
              type="text"
              placeholder="Search.."
              id={`txt${props.id}`}
              onKeyUp={(e) => this.handleKeyUp(e, props.id)}
            />
          </li>
          {props.filterObj.map((filter, index) => (
            <li
              key={index}
              onClick={(e) => this.handleClick(e, props.id + index)}
            >
              <input
                className="pull-left"
                name={props.name}
                value={props.valueObj[index]}
                onClick={(e) => e.stopPropagation()}
                id={props.id + index}
                onChange={(event) => props.onChange(event.target.value)}
                type="checkbox"
              />
              <span className="filter-text-space"> {filter}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
export default TableFilters;
